




import {
  ConnectionAemEnvironmentState,
  addConnectionAemEnvironmentConnection,
  connectionName as aemEnvConnectionName,
} from '@owc/connection-aem-environment';
import i18n from './i18n/i18n';
import { AppBase } from './AppBase';
import { logger } from './utils/logger';
import { SeamlessCoreStore } from '@seamless/store';
import FssInput from './components/fss-input/fss-input.vue';
import { VueSeamlessStore } from '@seamless/vue-store-plugin';
import { Component, Vue, Prop } from 'vue-property-decorator';

if (!window.aemNamespace) {
  Vue.use(new VueSeamlessStore());
}

@Component({
  i18n,
  components: { FssInput },
  mixins: [new VueSeamlessStore().mixin],
})
export default class App extends AppBase {
  store!: SeamlessCoreStore;

  @Prop()
  componentId!: string;

  created(): void {
    addConnectionAemEnvironmentConnection().then(() => {
      this.store.subscribe(aemEnvConnectionName, this.onAemEvent);
    });
  }

  onAemEvent(state: ConnectionAemEnvironmentState): void {
    const { language, country, stage } = state;
    logger.debug('Running in AEM environment. Initialising the with the following config: ', state);

    this.initWithMarketConfig(country, language, stage);
  }
}
